import React, {Component} from "react";
import TableCell from "@amzn/meridian/table/table-cell";
import {FormattedMessage} from "react-intl";

/**
 * This class is currently used by floor view to show the details for packages in a hybrid cart
 */
export default class OVBinTableCell extends Component {
    render() {

        const cart = this.props.cart

        return (
            <TableCell columnSpan={4}>
                <FormattedMessage id="ov.bin" defaultMessage="OV Bin"/> {cart.label}.OV: ({cart.packageCount})
                packages
            </TableCell>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/floor/OVBinTableCell.js